import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cream py-16 sm:py-20" data-id="element-120" data-mp="4uhzz22loth2">
      <div className="mx-auto max-w-2xl px-5" data-id="element-121" data-mp="4xcl6vtfuibj">
        <div className="rounded-3xl border-2 border-rose/20 bg-white p-8 text-center shadow-lg shadow-rose/10 sm:p-10" data-id="element-122" data-mp="9u39u7jb6m8k">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-blush" data-id="element-123" data-mp="eu8tp1jc74g3">
            <ShieldCheckIcon className="h-8 w-8 text-rose-deep" data-id="element-124" data-mp="jrr30t19nlom" />
          </span>
          <h2 className="mt-5 font-display text-2xl font-black text-ink sm:text-3xl" data-id="element-125" data-mp="nt2nyl973iqh">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink/75" data-id="element-126" data-mp="smxd447kkpwy">
            Abrís los tomos. Los aplicás en tu perfil. Si en 7 días no es lo que esperabas:
          </p>
          <p className="mt-3 font-display text-xl font-bold text-rose-deep" data-id="element-127" data-mp="12kldb9ny2pmi">
            devolución del 100%
          </p>
          <p className="mt-1 text-sm text-ink/60" data-id="element-128" data-mp="17g0k5hnjbl9f">sin formularios, sin drama.</p>
          <p className="mt-5 inline-block rounded-full bg-blush px-4 py-2 text-sm font-semibold text-ink" data-id="element-129" data-mp="25t8d8o72w3qm">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}